module.exports = __webpack_public_path__ + "static/media/feature2tools.77acea38.png";